import { render } from "./CatalogSectionHistory.vue?vue&type=template&id=465ac7d6"
import script from "./CatalogSectionHistory.vue?vue&type=script&lang=js"
export * from "./CatalogSectionHistory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__